// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomizationBar_container__3aCBJ","label":"CustomizationBar_label__Sn2r7","stripeTypes":"CustomizationBar_stripeTypes__3aU8A"};